import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loading: -1,
  },
  data: [],
  error: null,
};

export default function reducer(state = initialState, action) {
  const {
    type, payload,
  } = action;

  switch (type) {
    case ACTION_TYPES.WEBCHAT_MINIMUM_FEE_GET_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loading: 0,
        },
      };
    case ACTION_TYPES.WEBCHAT_MINIMUM_FEE_GET_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loading: 1,
        },
        data: payload.data,
      };
    case ACTION_TYPES.WEBCHAT_MINIMUM_FEE_GET_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loading: 2,
        },
      };
    default:
      return state;
  }
}
